/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';

import {
  GoogleAnalyticsConstants,
  GoogleAnalyticsDisplayedEvent,
  GoogleAnalyticsEventContextWrapper,
} from '@vvoyages/google-analytics';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';
import ClaimBookingRadioGroup from './controls/ClaimBookingRadioGroup';

const CURRENT_USER_ID = 'current';

type Sailor = {
  clientId: string;
  [key: string]: any;
};

type ClaimBookingEmailSelectProps = {
  tabId: string;
  data: {
    sailors: Sailor[];
    bookingNumber: string;
    showConfirmation: boolean;
  };
  currentUser: null | {
    email: string;
  };
  onSubmit: Function;
  onCancel: () => void;
};

const ClaimBookingEmailSelect: React.FC<ClaimBookingEmailSelectProps> = ({
  tabId,
  data,
  currentUser,
  onSubmit,
  onCancel,
}) => {
  const appUiData = useAppUiData();
  const [matchedSailor] = data.sailors;
  const sailors = useMemo(
    () => [{ clientId: CURRENT_USER_ID, email: currentUser?.email }, matchedSailor],
    [currentUser, matchedSailor],
  );

  const [selectedSailor, setSelectedSailor] = useState(sailors?.[0]);

  const handleChange = (value: Sailor) => {
    setSelectedSailor(value);
  };

  const handleSubmit = () => {
    const value = {
      bookingNumber: data.bookingNumber,
      sailors: [matchedSailor],
      updateProfileEmail: selectedSailor.clientId !== CURRENT_USER_ID,
      isManualEntry: false,
    };
    onSubmit(value);
  };

  return (
    <WizardStep tabId={tabId}>
      <GoogleAnalyticsEventContextWrapper category="VV-account-sign-in|we-found-your-booking">
        <GoogleAnalyticsDisplayedEvent eventAction={GoogleAnalyticsConstants.EVENT_ACTION.DISPLAYED} />
        <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.selectEmailTitle]}</h2>
        <p className={styles.subtitle}>{appUiData[appUiIds.claimBooking.selectEmailSubtitle]}</p>
        <form className={styles.selectForm}>
          <div className={styles.radioGroup}>
            <ClaimBookingRadioGroup
              sailors={sailors}
              selectedSailor={selectedSailor}
              onChange={handleChange}
              labelFunction={(sailor) => sailor.email}
            />
          </div>
          <Button variant="primary" onClick={handleSubmit} disabled={false} className={styles.buttonNext}>
            {appUiData[appUiIds.claimBooking.next]}
          </Button>
          <Button onClick={onCancel} className={styles.cancelLink}>
            {appUiData[appUiIds.commonLabels.cancel]}
          </Button>
        </form>
      </GoogleAnalyticsEventContextWrapper>
    </WizardStep>
  );
};

export default ClaimBookingEmailSelect;
